import { defineMessages } from 'react-intl';
import { addSchemaField } from '@redturtle/iovisit-theme/config';

const messages = defineMessages({
  title: {
    id: 'Titolo',
    defaultMessage: 'Titolo',
  },
  show_block_bg: {
    id: 'Mostra lo sfondo del blocco',
    defaultMessage: 'Mostra lo sfondo del blocco',
  },
  card_bg: {
    id: 'Colore di sfondo della card',
    defaultMessage: 'Colore di sfondo della card',
  },
  block_bg: {
    id: 'Colore di sfondo del blocco',
    defaultMessage: 'Colore di sfondo del blocco',
  },
  image_bg: {
    id: 'Immagine di sfondo',
    defaultMessage: 'Immagine di sfondo',
  },
  color_title: {
    id: 'Colore del titolo',
    defaultMessage: 'Colore del titolo',
  },
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  tertiary: {
    id: 'tertiary',
    defaultMessage: 'Terziario',
  },
  white: {
    id: 'white',
    defaultMessage: 'Bianco',
  },
});

/** DEFAULT **/

const getDefaultSchema = (schema, formData, intl, position = 0) => {
  let pos = position;

  addSchemaField(
    schema,
    'image_bg',
    intl.formatMessage(messages.image_bg),
    null,
    { widget: 'object_browser', mode: 'image', allowExternals: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'color_title',
    intl.formatMessage(messages.color_title),
    null,
    {
      widget: 'color_list',
      colors: [
        { name: 'black', label: 'Nero' },
        { name: 'white', label: 'Bianco' },
      ],
      defaultValue: 'primary',
    },
    pos,
  );
  pos++;
  addSchemaField(
    schema,
    'show_block_bg',
    intl.formatMessage(messages.show_block_bg),
    null,
    { type: 'boolean' },
    pos,
  );
  pos++;
  addSchemaField(
    schema,
    'background_color',
    intl.formatMessage(messages.block_bg),
    null,
    {
      widget: 'color_list',
      colors: [
        {
          name: 'primary',
          label: intl.formatMessage(messages.primary),
        },
        {
          name: 'secondary',
          label: intl.formatMessage(messages.secondary),
        },
        {
          name: 'tertiary',
          label: intl.formatMessage(messages.tertiary),
        },
      ],
      defaultValue: 'primary',
    },
    pos,
  );
  pos++;

  return pos;
};

export default getDefaultSchema;
